/* Elegance Arabie — interactions du thème (sans dépendance). */
(function () {
  'use strict';

  var mouvementReduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formaterPrix(centimes) {
    var entier = centimes % 100 === 0;
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: entier ? 0 : 2,
      maximumFractionDigits: entier ? 0 : 2,
    }).format(centimes / 100);
  }

  /* ---------- Apparition au défilement ---------- */
  var observateur = null;
  function initialiserApparitions(racine) {
    var elements = (racine || document).querySelectorAll('.apparition:not(.est-visible)');
    if (mouvementReduit || !('IntersectionObserver' in window)) {
      elements.forEach(function (el) { el.classList.add('est-visible'); });
      return;
    }
    if (!observateur) {
      observateur = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (entree) {
          if (entree.isIntersecting) {
            entree.target.classList.add('est-visible');
            observateur.unobserve(entree.target);
            animerCompteur(entree.target.querySelector('[data-compteur]'));
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    elements.forEach(function (el) { observateur.observe(el); });
  }

  function animerCompteur(el) {
    if (!el || mouvementReduit) return;
    var cible = parseInt(el.getAttribute('data-compteur'), 10) || 0;
    var debut = null;
    function pas(t) {
      if (!debut) debut = t;
      var p = Math.min(1, (t - debut) / 1200);
      el.textContent = Math.round(cible * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(pas);
    }
    requestAnimationFrame(pas);
  }

  /* ---------- En-tête : état au défilement, parallaxe du visuel d'accueil ---------- */
  var entete = document.querySelector('[data-entete]');
  var parallaxe = document.querySelector('[data-parallaxe]');
  var enAttente = false;
  function surDefilement() {
    if (enAttente) return;
    enAttente = true;
    requestAnimationFrame(function () {
      var y = window.scrollY;
      if (entete) entete.classList.toggle('entete--descendu', y > 24);
      if (parallaxe && !mouvementReduit) parallaxe.style.transform = 'translateY(' + Math.min(y * 0.12, 40) + 'px)';
      enAttente = false;
    });
  }
  window.addEventListener('scroll', surDefilement, { passive: true });
  surDefilement();

  /* ---------- Menu mobile ---------- */
  function basculerMenu(bouton, ouvrir) {
    var menu = document.querySelector('[data-menu-mobile]');
    if (!menu) return;
    var ouvert = typeof ouvrir === 'boolean' ? ouvrir : menu.hidden;
    menu.hidden = !ouvert;
    bouton.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
  }

  /* ---------- Tiroir panier ---------- */
  var focusAvantPanier = null;
  function tiroir() { return document.querySelector('[data-panier-tiroir]'); }

  function ouvrirPanier() {
    var t = tiroir();
    if (!t) return;
    focusAvantPanier = document.activeElement;
    document.documentElement.classList.add('panier-ouvert');
    window.setTimeout(function () {
      var fermer = t.querySelector('.panier-tiroir__fermer');
      (fermer || t).focus();
    }, 60);
  }

  function fermerPanier() {
    if (!document.documentElement.classList.contains('panier-ouvert')) return;
    document.documentElement.classList.remove('panier-ouvert');
    if (focusAvantPanier && focusAvantPanier.focus) focusAvantPanier.focus();
  }

  function idSectionPanierPage() {
    var page = document.querySelector('[data-panier-page]');
    var section = page && page.closest('.shopify-section');
    return section ? section.id.replace('shopify-section-', '') : null;
  }

  function sectionsDemandees() {
    var ids = ['cart-drawer'];
    var idPage = idSectionPanierPage();
    if (idPage) ids.push(idPage);
    return ids;
  }

  function appliquerSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var actuelle = document.getElementById('shopify-section-' + id);
      if (!actuelle || !sections[id]) return;
      var doc = new DOMParser().parseFromString(sections[id], 'text/html');
      var nouvelle = doc.getElementById('shopify-section-' + id);
      if (nouvelle) actuelle.innerHTML = nouvelle.innerHTML;
    });
    var t = tiroir();
    if (t) mettreAJourCompteur(parseInt(t.getAttribute('data-nombre'), 10) || 0);
  }

  function mettreAJourCompteur(nombre) {
    var compteur = document.querySelector('[data-panier-compteur]');
    var texte = document.querySelector('[data-panier-compteur-texte]');
    if (texte) texte.textContent = nombre + ' article(s) dans le panier';
    if (!compteur) return;
    var ancien = parseInt(compteur.textContent, 10) || 0;
    compteur.textContent = nombre;
    compteur.hidden = nombre === 0;
    if (nombre > ancien) {
      compteur.classList.remove('panier-compteur--rebond');
      void compteur.offsetWidth;
      compteur.classList.add('panier-compteur--rebond');
    }
  }

  function rafraichirPanier() {
    return fetch(window.location.pathname + '?sections=' + sectionsDemandees().join(','), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(appliquerSections)
      .catch(function () {});
  }

  function changerQuantite(cle, quantite, declencheur) {
    var ligne = declencheur && declencheur.closest('.ligne-panier');
    if (ligne) ligne.classList.add('est-en-cours');
    return fetch(racineShopify() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: cle, quantity: quantite, sections: sectionsDemandees(), sections_url: window.location.pathname }),
    })
      .then(function (r) { return r.json(); })
      .then(function (panier) {
        if (panier && panier.sections) appliquerSections(panier.sections);
        else return rafraichirPanier();
      })
      .catch(function () { window.location.reload(); });
  }

  function racineShopify() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
  }

  function ajouterAuPanier(formulaire) {
    var bouton = formulaire.querySelector('[data-ajout-bouton]');
    var erreur = formulaire.querySelector('[data-ajout-erreur]');
    var libelle = bouton ? bouton.textContent : '';
    if (erreur) erreur.hidden = true;
    if (bouton) bouton.disabled = true;

    var donnees = new FormData(formulaire);
    donnees.append('sections', sectionsDemandees().join(','));
    donnees.append('sections_url', window.location.pathname);

    fetch(racineShopify() + 'cart/add.js', { method: 'POST', body: donnees, headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json().then(function (json) {
          if (!r.ok) throw json;
          return json;
        });
      })
      .then(function (reponse) {
        appliquerSections(reponse.sections);
        ouvrirPanier();
        if (bouton) {
          bouton.textContent = 'Ajouté au panier ✓';
          window.setTimeout(function () { bouton.textContent = libelle; }, 2200);
        }
      })
      .catch(function (e) {
        if (erreur) {
          erreur.textContent = (e && (e.description || e.message)) || "Impossible d'ajouter ce parfum au panier pour le moment.";
          erreur.hidden = false;
        }
      })
      .finally(function () {
        if (bouton) bouton.disabled = false;
      });
  }

  /* ---------- Fiche produit : quantité, variante, total ---------- */
  function mettreAJourQuantite(formulaire) {
    var champ = formulaire.querySelector('[data-quantite]');
    if (!champ) return;
    var max = parseInt(champ.max, 10) || 10;
    var valeur = Math.max(1, Math.min(max, parseInt(champ.value, 10) || 1));
    champ.value = valeur;
    var moins = formulaire.querySelector('[data-quantite-moins]');
    var plus = formulaire.querySelector('[data-quantite-plus]');
    if (moins) moins.disabled = valeur <= 1;
    if (plus) plus.disabled = valeur >= max;
    var total = formulaire.querySelector('[data-total]');
    var montant = formulaire.querySelector('[data-total-montant]');
    var prix = parseInt(champ.getAttribute('data-prix-unitaire'), 10) || 0;
    if (total && montant) {
      total.hidden = valeur <= 1;
      montant.textContent = formaterPrix(prix * valeur);
    }
  }

  function changerVariante(select) {
    var formulaire = select.closest('form');
    var option = select.options[select.selectedIndex];
    var champ = formulaire.querySelector('[data-quantite]');
    var prix = parseInt(option.getAttribute('data-prix'), 10) || 0;
    if (champ) {
      champ.max = option.getAttribute('data-max') || 10;
      champ.setAttribute('data-prix-unitaire', prix);
    }
    var affichage = document.querySelector('[data-prix-variante]');
    if (affichage) affichage.textContent = formaterPrix(prix);
    var url = new URL(window.location.href);
    url.searchParams.set('variant', select.value);
    window.history.replaceState({}, '', url.toString());
    mettreAJourQuantite(formulaire);
  }

  /* ---------- Galerie ---------- */
  function initialiserGalerie(galerie) {
    if (galerie.dataset.pret) return;
    galerie.dataset.pret = '1';
    var diapos = galerie.querySelectorAll('[data-galerie-diapo]');
    var index = 0;
    var message = galerie.querySelector('[data-galerie-message]');
    var lightbox = galerie.querySelector('[data-galerie-lightbox]');

    function aller(i) {
      if (!diapos.length) return;
      index = (i + diapos.length) % diapos.length;
      diapos.forEach(function (d, n) { d.classList.toggle('est-active', n === index); });
      galerie.querySelectorAll('[data-galerie-aller]').forEach(function (b) {
        if (parseInt(b.getAttribute('data-galerie-aller'), 10) === index) b.setAttribute('aria-current', 'true');
        else b.removeAttribute('aria-current');
      });
    }

    function zoomer() {
      var active = diapos[index] && diapos[index].querySelector('[data-grand]');
      if (!lightbox || !active) return;
      var image = lightbox.querySelector('img');
      if (image) {
        image.removeAttribute('srcset');
        image.src = active.getAttribute('data-grand');
      }
      if (typeof lightbox.showModal === 'function') lightbox.showModal();
      else lightbox.setAttribute('open', '');
    }

    galerie.addEventListener('click', function (e) {
      var cible = e.target;
      if (cible.closest('[data-galerie-precedente]')) aller(index - 1);
      else if (cible.closest('[data-galerie-suivante]')) aller(index + 1);
      else if (cible.closest('[data-galerie-aller]')) aller(parseInt(cible.closest('[data-galerie-aller]').getAttribute('data-galerie-aller'), 10));
      else if (cible.closest('[data-galerie-zoom]') || cible.closest('[data-galerie-zoom-actif]')) zoomer();
      else if (cible.closest('[data-galerie-lightbox-fermer]') || cible === lightbox) {
        if (lightbox.close) lightbox.close(); else lightbox.removeAttribute('open');
      } else if (cible.closest('[data-galerie-favori]')) {
        var fav = cible.closest('[data-galerie-favori]');
        var actif = fav.getAttribute('aria-pressed') !== 'true';
        fav.setAttribute('aria-pressed', actif ? 'true' : 'false');
        fav.setAttribute('aria-label', actif ? 'Retirer des favoris' : 'Marquer comme favori');
        if (message) message.textContent = actif ? 'Ajouté à vos favoris pour cette visite.' : 'Retiré de vos favoris.';
      } else if (cible.closest('[data-galerie-partager]')) {
        var titre = cible.closest('[data-galerie-partager]').getAttribute('data-titre') + ' — ' + document.title.split(' — ').pop();
        var url = window.location.href;
        if (navigator.share) {
          navigator.share({ title: titre, url: url }).catch(function () {});
        } else if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(url).then(function () { if (message) message.textContent = 'Lien copié dans le presse-papiers.'; });
        } else if (message) {
          message.textContent = 'Lien à copier : ' + url;
        }
      }
    });

    var cadre = galerie.querySelector('[data-galerie-cadre]');
    var departX = null;
    if (cadre && diapos.length > 1) {
      cadre.addEventListener('touchstart', function (e) { departX = e.touches[0] ? e.touches[0].clientX : null; }, { passive: true });
      cadre.addEventListener('touchend', function (e) {
        if (departX === null) return;
        var delta = (e.changedTouches[0] ? e.changedTouches[0].clientX : departX) - departX;
        if (delta > 40) aller(index - 1);
        else if (delta < -40) aller(index + 1);
        departX = null;
      });
    }
  }

  function initialiser(racine) {
    initialiserApparitions(racine);
    (racine || document).querySelectorAll('[data-galerie]').forEach(initialiserGalerie);
    (racine || document).querySelectorAll('form.ajouter-panier').forEach(mettreAJourQuantite);
  }

  /* ---------- Délégation d'événements ---------- */
  document.addEventListener('click', function (e) {
    var cible = e.target;

    var boutonMenu = cible.closest('[data-menu-bouton]');
    if (boutonMenu) { basculerMenu(boutonMenu); return; }

    if (cible.closest('[data-panier-ouvrir]')) {
      if (!tiroir()) return;
      e.preventDefault();
      ouvrirPanier();
      rafraichirPanier();
      return;
    }
    if (cible.closest('[data-panier-fermer]')) { fermerPanier(); return; }

    var changer = cible.closest('[data-panier-changer]');
    if (changer) {
      e.preventDefault();
      changerQuantite(changer.getAttribute('data-panier-changer'), Math.max(0, parseInt(changer.getAttribute('data-quantite'), 10) || 0), changer);
      return;
    }

    var moins = cible.closest('[data-quantite-moins]');
    var plus = cible.closest('[data-quantite-plus]');
    if (moins || plus) {
      var formulaire = (moins || plus).closest('form');
      var champ = formulaire.querySelector('[data-quantite]');
      champ.value = (parseInt(champ.value, 10) || 1) + (plus ? 1 : -1);
      mettreAJourQuantite(formulaire);
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-quantite]')) mettreAJourQuantite(e.target.closest('form'));
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-selecteur-variante]')) changerVariante(e.target);
  });

  document.addEventListener('submit', function (e) {
    var formulaire = e.target.closest('form.ajouter-panier');
    if (!formulaire || !tiroir() || !window.fetch) return;
    e.preventDefault();
    ajouterAuPanier(formulaire);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      fermerPanier();
      var bouton = document.querySelector('[data-menu-bouton][aria-expanded="true"]');
      if (bouton) basculerMenu(bouton, false);
      return;
    }
    if (e.key === 'Tab' && document.documentElement.classList.contains('panier-ouvert')) {
      var t = tiroir();
      var focusables = t ? t.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])') : [];
      if (!focusables.length) return;
      var premier = focusables[0];
      var dernier = focusables[focusables.length - 1];
      if (e.shiftKey && (document.activeElement === premier || document.activeElement === t)) { e.preventDefault(); dernier.focus(); }
      else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
    }
  });

  /* Éditeur de thème Shopify : réinitialise les sections rechargées. */
  document.addEventListener('shopify:section:load', function (e) { initialiser(e.target); });

  initialiser(document);
})();
